module.exports = __webpack_public_path__ + "static/media/banner-parque-para-todos.fac825b3.jpg";